(function () {
  function init(root) {
    var sections = (root || document).querySelectorAll('[data-lukzer-carousel]');
    sections.forEach(function (section) {
      if (section.dataset.lzInitialized === 'true' || section.dataset.carouselReady === 'true') return;
      var viewport = section.querySelector('.lukzer-product-carousel__viewport');
      var track = section.querySelector('[data-carousel-track]');
      var originals = track ? Array.prototype.slice.call(track.children) : [];
      if (!viewport || !track || originals.length < 1) return;

      section.dataset.carouselReady = 'true';
      section.dataset.lzInitialized = 'true';
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = section.dataset.autoplay === 'true' && !reduceMotion;

      if (window.matchMedia('(max-width: 749px)').matches) {
        initMobileCarousel(section, viewport, track, originals, autoplay, reduceMotion);
        return;
      }

      if (originals.length === 1) {
        initTilt(section, reduceMotion);
        return;
      }

      var cloneCount = Math.min(5, originals.length);
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.slice(-cloneCount).forEach(function (slide) { before.appendChild(slide.cloneNode(true)); });
      originals.slice(0, cloneCount).forEach(function (slide) { after.appendChild(slide.cloneNode(true)); });
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
      initTilt(section, reduceMotion);

      var index = cloneCount;
      var timer;
      var moving = false;
      var dragging = false;
      var startX = 0;
      var deltaX = 0;
      var baseX = 0;
      var dragged = false;
      var suppressClickUntil = 0;

      function gap() { return parseFloat(getComputedStyle(track).gap) || 0; }
      function step() { return track.children[0].getBoundingClientRect().width + gap(); }
      function translate(animate) {
        moving = animate && !reduceMotion;
        track.style.transition = moving ? 'transform .62s cubic-bezier(.22,.61,.36,1)' : 'none';
        baseX = -(index * step());
        track.style.transform = 'translate3d(' + baseX + 'px,0,0)';
      }
      function normalize(event) {
        if (event && (event.target !== track || event.propertyName !== 'transform')) return;
        moving = false;
        if (index >= cloneCount + originals.length) index -= originals.length;
        if (index < cloneCount) index += originals.length;
        translate(false);
        play();
      }
      function move(direction) {
        if (moving || dragging) return;
        index += direction;
        translate(true);
      }
      function stop() { window.clearTimeout(timer); }
      function play() {
        stop();
        if (autoplay) timer = window.setTimeout(function () { move(1); }, parseInt(section.dataset.autoplaySpeed, 10) || 2800);
      }

      section.querySelectorAll('[data-carousel-direction]').forEach(function (button) {
        button.addEventListener('click', function () { stop(); move(parseInt(button.dataset.carouselDirection, 10)); });
      });
      track.addEventListener('transitionend', normalize);
      viewport.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, button, input, select, textarea, form, [data-lukzer-carousel-atc]')) return;
        if (moving) return;
        dragging = true; dragged = false; startX = event.clientX; deltaX = 0; stop();
        viewport.setPointerCapture && viewport.setPointerCapture(event.pointerId);
        track.style.transition = 'none';
      });
      viewport.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 6) dragged = true;
        track.style.transform = 'translate3d(' + (baseX + deltaX) + 'px,0,0)';
      });
      function release(event) {
        if (!dragging) return;
        dragging = false;
        if (Math.abs(deltaX) < 2) {
          dragged = false;
          translate(false);
          play();
          return;
        }
        if (Math.abs(deltaX) > Math.min(70, step() * .2)) {
          index += deltaX < 0 ? 1 : -1;
          suppressClickUntil = Date.now() + 350;
          section.dataset.suppressCarouselClickUntil = String(suppressClickUntil);
          translate(true);
        } else {
          dragged = false;
          translate(false);
          play();
        }
      }
      viewport.addEventListener('pointerup', release);
      viewport.addEventListener('pointercancel', release);
      viewport.addEventListener('click', function (event) {
        if (!dragged || Date.now() > suppressClickUntil) {
          dragged = false;
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        dragged = false;
      }, true);
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', play);
      document.addEventListener('lukzer:resize:stable', function () { moving = false; translate(false); });
      translate(false);
      play();
    });
  }

  function initMobileCarousel(section, viewport, track, slides, autoplay, reduceMotion) {
    var timer;
    var scrolling = false;

    function gap() { return parseFloat(getComputedStyle(track).gap) || 0; }
    function step() { return slides[0].getBoundingClientRect().width + gap(); }
    function currentIndex() {
      return Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / step())));
    }
    function move(direction) {
      if (scrolling || slides.length < 2) return;
      var next = currentIndex() + direction;
      next = Math.max(0, Math.min(slides.length - 1, next));
      scrolling = true;
      viewport.scrollTo({ left: next * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      window.setTimeout(function () { scrolling = false; }, reduceMotion ? 0 : 420);
    }
    function stop() { window.clearTimeout(timer); }
    function play() {
      stop();
      if (!autoplay || slides.length < 2) return;
      timer = window.setTimeout(function () {
        var next = currentIndex() >= slides.length - 1 ? 0 : currentIndex() + 1;
        viewport.scrollTo({ left: next * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
        play();
      }, parseInt(section.dataset.autoplaySpeed, 10) || 2800);
    }

    section.querySelectorAll('[data-carousel-direction]').forEach(function (button) {
      button.addEventListener('click', function () {
        stop();
        move(parseInt(button.dataset.carouselDirection, 10));
        play();
      });
    });
    viewport.addEventListener('pointerdown', stop, { passive: true });
    viewport.addEventListener('pointerup', play, { passive: true });
    viewport.addEventListener('touchend', play, { passive: true });
    section.addEventListener('mouseenter', stop);
    section.addEventListener('mouseleave', play);
    play();
  }

  function initTilt(section, reduceMotion) {
    if (reduceMotion || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

    section.querySelectorAll('.bookshelf-card').forEach(function (card) {
      card.addEventListener('pointermove', function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--card-tilt-x', (-y * 5).toFixed(2) + 'deg');
        card.style.setProperty('--card-tilt-y', (x * 5).toFixed(2) + 'deg');
      });

      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--card-tilt-x', '0deg');
        card.style.setProperty('--card-tilt-y', '0deg');
      });
    });
  }

  function rootUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function openCartExperience() {
    var drawer = document.querySelector('cart-drawer, .cart_canvas, #cart_canvas, [data-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    var trigger = document.querySelector('[data-toggle="canvas"][data-target="#cart_canvas"], .site-header__cart, .block_cart_top a, .header-cart a');
    if (trigger) {
      trigger.click();
      return true;
    }

    if (document.querySelector('#desktop_cart')) {
      document.querySelector('#desktop_cart').classList.add('active');
      var overlay = document.querySelector('.sidebar-overlay');
      if (overlay) overlay.classList.add('act');
      return true;
    }

    return false;
  }

  function setAtcState(button, state, message) {
    if (!button) return;
    var label = button.querySelector('span') || button;
    if (!button.dataset.originalLabel) button.dataset.originalLabel = label.textContent.trim();

    button.classList.toggle('loading', state === 'loading');
    button.disabled = state === 'loading' || button.classList.contains('is-disabled') || button.hasAttribute('data-sold-out');

    if (state === 'loading') label.textContent = 'Adding...';
    if (state === 'added') label.textContent = 'Added';
    if (state === 'idle') label.textContent = button.dataset.originalLabel || 'Add to Cart';

    var form = button.closest('[data-lukzer-carousel-form]');
    if (!form) return;
    var feedback = form.querySelector('[data-lukzer-carousel-message]');
    if (!feedback) {
      feedback = document.createElement('span');
      feedback.className = 'bookshelf-card__message';
      feedback.setAttribute('data-lukzer-carousel-message', '');
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      form.appendChild(feedback);
    }
    feedback.textContent = message || '';
  }

  function refreshCartCount() {
    return fetch(rootUrl('/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('.CartCount, #CartCount, #CartCountCavas, .cart-count, [data-cart-count], .cart-count-bubble span').forEach(function (node) {
          node.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function refreshThemeCart() {
    var tasks = [refreshCartCount()];

    if (window.jQuery && document.querySelector('#cart-info')) {
      tasks.push(new Promise(function (resolve) {
        window.jQuery.get(rootUrl('/cart?view=json'), function (html) {
          window.jQuery('#cart-info').html(html);
        }).always(function () {
          if (window.nuranium && typeof window.nuranium.updateMiniCart === 'function') {
            window.nuranium.updateMiniCart();
          }
          resolve();
        });
      }));
    }

    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    return Promise.all(tasks);
  }

  function addCarouselForm(form, button) {
    if (!form || form.dataset.lukzerCarouselSubmitting === 'true') return;
    var formData = new FormData(form);
    var variantId = formData.get('id');
    if (!variantId || (button && button.disabled)) return;

    form.dataset.lukzerCarouselSubmitting = 'true';
    setAtcState(button, 'loading', '');

    var addPromise;
    if (window.LukzerCartDrawer && typeof window.LukzerCartDrawer.addToCart === 'function') {
      addPromise = window.LukzerCartDrawer.addToCart(formData);
    } else {
      addPromise = fetch(rootUrl('/cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: Number(formData.get('quantity') || 1) })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            throw new Error(payload.description || payload.message || 'Unable to add this item.');
          });
        }
        return refreshThemeCart();
      });
    }

    addPromise
      .then(function () {
        var openedCart = false;
        if (window.LukzerCartDrawer && typeof window.LukzerCartDrawer.openCartDrawer === 'function') {
          window.LukzerCartDrawer.openCartDrawer();
          openedCart = true;
        } else {
          openedCart = openCartExperience();
        }
        setAtcState(button, 'added', 'Added to cart');
        if (!openedCart) window.location.href = rootUrl('/cart');
        window.setTimeout(function () { setAtcState(button, 'idle', ''); }, 1400);
      })
      .catch(function (error) {
        setAtcState(button, 'idle', error.message || 'Unable to add this item.');
      })
      .finally(function () {
        form.dataset.lukzerCarouselSubmitting = 'false';
      });
  }

  function interceptCarouselAtc(event) {
    var form = event.target.closest && event.target.closest('[data-lukzer-carousel-form]');
    var button = event.target.closest && event.target.closest('[data-lukzer-carousel-atc]');

    if (event.type === 'click') {
      if (!button) return;
      form = button.closest('[data-lukzer-carousel-form]');
    }

    if (!form || !form.closest('[data-lukzer-carousel]')) return;
    var carousel = form.closest('[data-lukzer-carousel]');
    var suppressUntil = Number(carousel && carousel.dataset.suppressCarouselClickUntil || 0);

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (Date.now() <= suppressUntil) return;
    addCarouselForm(form, button || form.querySelector('[data-lukzer-carousel-atc]'));
  }

  window.addEventListener('click', interceptCarouselAtc, true);
  window.addEventListener('submit', interceptCarouselAtc, true);

  window.addEventListener('click', function (event) {
    var card = event.target.closest && event.target.closest('.bookshelf-card[data-product-url]');
    if (!card || !card.closest('[data-lukzer-carousel]')) return;
    if (event.target.closest('form, button, a, .add-to-cart-btn, [data-lukzer-carousel-form], [data-lukzer-carousel-atc]')) return;

    var carousel = card.closest('[data-lukzer-carousel]');
    var suppressUntil = Number(carousel && carousel.dataset.suppressCarouselClickUntil || 0);
    if (Date.now() <= suppressUntil) return;

    window.location.href = card.dataset.productUrl;
  });

  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var card = event.target.closest && event.target.closest('.bookshelf-card[data-product-url]');
    if (!card || event.target !== card || !card.closest('[data-lukzer-carousel]')) return;

    event.preventDefault();
    window.location.href = card.dataset.productUrl;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
